export default "__VITE_ASSET__CkTQ0lC0__ 288w, __VITE_ASSET__Cmg7mzn5__ 432w, __VITE_ASSET__D0HKIWqo__ 576w";